import React from 'react';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import { createOlafApplication } from 'olaf';

import { Route, Routes } from 'react-router-dom';

import App from './containers/App';
import commonReducer from './reducers/common';

import adminReducer from './reducers/admin';
import authSaga from './sagas/auth';
import adminSaga from './sagas/admin';
import rolesSaga from './sagas/roles';

import commonSaga from './sagas/common';
import eventsSaga from './sagas/events';
import eventReducer from './reducers/events';
import oddsHistoryReducer from './reducers/oddsHistory';
import oddsHistorySaga from './sagas/oddsHistory';
import autobookingReducer from './reducers/autobooking';
import autobookingSaga from './sagas/autobooking';
import matchTimelineReducer from './reducers/matchTimeline';
import matchTimeLineSaga from './sagas/matchTimeline';
import feedSettingsReducer from './reducers/feedSettings';
import feedSettingsSaga from './sagas/feedSettings';
import marketSettingsSaga from './sagas/marketSettings';
import marketSettingsReducer from './reducers/marketSettings';
import teamsSaga from './sagas/teams';
import teamsReducer from './reducers/teams';
import marketMarginsSaga from './sagas/marketMargins';
import marketMarginsReducer from './reducers/marketMargins';
import earlyPayoutSettingsReducer from './reducers/earlyPayoutSettings';
import earlyPayoutSettingsSaga from './sagas/earlyPayoutSettings';
import goldenGoalSettingsSaga from './sagas/goldenGoal';
import GoldenGoalSettingsReducer from './reducers/goldenGoalSettings';
import liveScoreStatusSaga from './sagas/liveScoreStatus';
import liveScoreStatusReducer from './reducers/liveScoreStatus';
import historicalEventsReducer from './reducers/historicalEvents';
import historicalEventsSaga from './sagas/historicalEvents';
import FeaturesFlagReducer from './reducers/featuresFlag';
import FeaturesFlagSaga from './sagas/featuresFlag';
import configurationSettingsReducer from './reducers/configurationSettings';
import configurationSettingsSaga from './sagas/configurationSettings';

/**
 *
 * @external 'node_modules/olaf'
 * @see {@link https://gitlab.com/providus.mu/fe-utils/olaf}
 */
/**
 * Olaf function to create usable aplications with passed routes, reducers, sagas and so on
 * @function createOlafApplication
 * @returns {Application}
 */
createOlafApplication({
  name: 'zoom-backoffice',
  thunk: true,
  hash: false,
  rootReactComponent: (
    <Routes>
      <Route path="*" element={<App />} />
    </Routes>
  ),
  getRootDomElement: () => document.body.children[0],
  reducers: {
    common: commonReducer,
    admin: adminReducer,
    events: eventReducer,
    oddsHistory: oddsHistoryReducer,
    autobooking: autobookingReducer,
    matchTimeline: matchTimelineReducer,
    feedSettings: feedSettingsReducer,
    marketSettings: marketSettingsReducer,
    teams: teamsReducer,
    marketMargins: marketMarginsReducer,
    liveScoreStatus: liveScoreStatusReducer,
    earlyPayoutSettings: earlyPayoutSettingsReducer,
    goldenGoalSettings: GoldenGoalSettingsReducer,
    historicalEvents: historicalEventsReducer,
    featuresFlag: FeaturesFlagReducer,
    configurationSettings: configurationSettingsReducer,
  },
  sagas: {
    common: commonSaga,
    auth: authSaga,
    user: adminSaga,
    users: rolesSaga,
    events: eventsSaga,
    oddsHistory: oddsHistorySaga,
    autobooking: autobookingSaga,
    matchTimeline: matchTimeLineSaga,
    feedSettings: feedSettingsSaga,
    marketSettings: marketSettingsSaga,
    teams: teamsSaga,
    marketMargins: marketMarginsSaga,
    liveScoreStatus: liveScoreStatusSaga,
    earlyPayoutSettings: earlyPayoutSettingsSaga,
    goldenGoalSettings: goldenGoalSettingsSaga,
    historicalEvents: historicalEventsSaga,
    featuresFlag: FeaturesFlagSaga,
    configurationSettings: configurationSettingsSaga,
  },
});
